// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gh20","top":"styles_top__3DklH","left":"styles_left__1BjmS","description":"styles_description__L43sc"};